import { render, staticRenderFns } from "./UploadImagemLogin.vue?vue&type=template&id=bb6450fa&"
import script from "./UploadImagemLogin.vue?vue&type=script&lang=js&"
export * from "./UploadImagemLogin.vue?vue&type=script&lang=js&"
import style0 from "./UploadImagemLogin.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports